const dashboardTestIDs = {
  dashboardScreen: 'dashboard-screen',
  dashboardAvatar: 'dashboard-avatar',
  dashboardGreetingHello: 'dashboard-greeting-hello',
  dashboardGreetingName: 'dashboard-greeting-name',

  dashboardBonusesLabel: 'dashboard-bonuses-label',
  dashboardBonusesView: 'dashboard-bonuses-view',
  dashboardBonusesHeader: 'dashboard-bonuses-header',
  dashboardBonusesShowHideButton: 'dashboard-bonuses-show-hide-button',
  dashboardBonusesShowHideText: 'dashboard-bonuses-show-hide-text',
  dashboardBonusesShowHideIcon: 'dashboard-bonuses-show-hide-icon',

  dashboardEdgeBanner: 'edge-banner',
  dashboardEdgeBannerTitle: 'edge-banner-title',
  dashboardEdgeBannerDescription: 'edge-banner-description',
  dashboardEdgeBannerSideTitle: 'edge-banner-side-title',
  dashboardEdgeBannerTrackNowButton: 'edge-banner-track-now-button',

  dashboardCabBanner: 'cab-banner',
  dashboardCabBannerTitle: 'cab-banner-title',
  dashboardCabBannerShowHide: 'cab-banner-show-hide',
  dashboardCabBannerDescription: 'cab-banner-description',
  dashboardCabBannerMotivation: 'cab-banner-motivation',
  dashboardCabBannerSideTitle: 'cab-banner-side-title',
  dashboardCabBannerLearnMoreLink: 'cab-banner-learn-more-link',

  dashboardCsbBanner: 'csb-banner',
  dashboardCsbBannerTitle: 'csb-banner-title',
  dashboardCsbBannerDescription: 'csb-banner-description',
  dashboardCsbBannerSideTitle: 'csb-banner-side-title',
  dashboardCsbBannerLearnMoreLink: 'csb-banner-learn-more-link',
  dashboardCsbBannerCurrentDate: 'csb-banner-current-date',
  dashboardCsbBannerDaysLeft: 'csb-banner-days-left',
  dashboardProgressBarBonusAmount: 'bonus-progressbar-amount',

  dashboardIncentiveTripBanner: 'text-only-incentive-trip-banner',
  dashboardIncentiveTripBannerTitle: 'text-only-incentive-trip-banner-title',
  dashboardIncentiveTripBannerDescription:
    'text-only-incentive-trip-banner-description',
  dashboardIncentiveTripBannerSideTitle:
    'text-only-incentive-trip-banner-side-title',
  dashboardIncentiveTripBannerLearnMoreLink:
    'text-only-incentive-trip-banner-learn-more-link',
  dashboardIncentiveTripBannerCaption:
    'text-only-incentive-trip-banner-caption',
  dashboardIncentiveTripBannerDivider:
    'text-only-incentive-trip-banner-divider',
  dashboardIncentiveTripBannerDataContainer:
    'text-only-incentive-trip-banner-data-container',
  dashboardIncentiveTripBannerProgressBarContainer:
    'text-only-incentive-trip-banner-progressbar-container',
  dashboardIncentiveTripBannerProgressCompleteIcon:
    'text-only-incentive-trip-banner-progress-complete-icon',
  dashboardIncentiveTripBannerProgressPendingBox:
    'text-only-incentive-trip-banner-progress-pending-box',
  dashboardIncentiveTripBannerProgressBoxesContainer:
    'text-only-incentive-trip-banner-progress-boxes-container',

  bbBanner: 'bbb-banner',
  bbBannerTitle: 'bbb-banner-title',
  bbBannerDescription: 'bbb-banner-description',
  bbBannerSideTitle: 'bbb-banner-side-title',
  bbBannerLearnMoreLink: 'bbb-banner-learn-more-link',
  bbBannerContributingCoaches: 'bbb-banner-contributing-coaches',
  bbBannerContributingCoachesBtn: 'bbb-banner-contributing-coaches-button',
  bbBannerCoachesCount: 'bbb-banner-contributing-coaches-count',
  bonusProgressBarMidPercentLabel: 'bonus-progressbar-percent-mid-label',
  bonusProgressBarMidSecondPercentLabel:
    'bonus-progressbar-percent-mid-second-label',
  bonusProgressBarMinPercentLabel: 'bonus-progressbar-percent-min-label',
  bonusProgressBarMaxPercentLabel: 'bonus-progressbar-percent-max-label',

  bonusProgressBarMidThresholdLabel: 'bonus-progressbar-mid-label',
  bonusProgressBarMidSecondThresholdLabel: 'bonus-progressbar-mid-second-label',
  bonusProgressBarMinThresholdLabel: 'bonus-progressbar-min-label',
  bonusProgressBarMaxThresholdLabel: 'bonus-progressbar-max-label',
  dashboardProgressBarCurrentDate: 'bonus-progressbar-current-date',
  dashboardProgressBarDaysLeft: 'bonus-progressbar-days-left',
  dashboardProgressBarEarned: 'bonus-progressbar-earned',
  dashboardProgressBarLabel: 'bonus-progressbar-label',
  dashboardProgressBarOrderingEntitiesBox: 'bonus-progressbar-box',
  dashboardOrderingEntitiesNumber: 'ordering-entities-number',
  dashboardOrderingEntitiesNumberChecked: 'ordering-entities-number-checked',

  clientsToContactView: 'clients-to-contact-view',
  clientsToContactEmptyViewMessage: 'clients-to-contact-empty-view-message',
  clientsToContactEmptyViewTitle: 'clients-to-contact-empty-view-title',
  clientsToContactShowAllButton: 'clients-to-contact-show-all',

  // "Pin added" overlay screen
  dashboardPinAddedTitle: 'dashboard-pin-added-title',
  dashboardPinAddedMessage: 'dashboard-pin-added-first-message',
  dashboardPinAddedSecondMessage: 'dashboard-pin-added-second-message',
  dashboardPinAddedDoneButton: 'dashboard-pin-added-done-btn',
};

export default dashboardTestIDs;
